export function getErrorMessage(error) {
    if (typeof error.xhr.response === "object" &&
        error.xhr.response !== null &&
        error.xhr.response.hasOwnProperty("message")) {
        return error.xhr.response.message;
    }
    return error.message;
}
export function getRequestCode(error) {
    if (typeof error.xhr.response === "object" &&
        error.xhr.response !== null &&
        error.xhr.response.hasOwnProperty("status")) {
        return error.xhr.response.status;
    }
    return error.status;
}
//# sourceMappingURL=errorParser.js.map